import { multipleUnsubscribe } from '../utils';

export function AutoUnsubscribe(constructor: unknown): void {
  if (typeof constructor === 'function' && 'prototype' in constructor) {
    const original = constructor.prototype.ngOnDestroy;
    // eslint-disable-next-line
    constructor.prototype.ngOnDestroy = function (...args: unknown[]): void {
      Object.keys(this).forEach((prop: string) => {
        const property = this[prop];
        if (property && typeof property.unsubscribe === 'function') {
          property.unsubscribe();
        }

        if (property && Array.isArray(property)) {
          multipleUnsubscribe(property);
        }
      });

      if (original && typeof original === 'function') {
        original.apply(this, args);
      }
    };
  }
}
